export default __webpack_public_path__ + "static/media/MyriadProBold.ba6deb51.ttf";